import React, { Component } from 'react'

export default class BlogPost extends Component {
  render() {
    return (
      <div>BlogPost</div>
    )
  }
}
